<template>
    <el-dialog
        title="选择区域"
        :visible.sync="treeVisible"
        width="600px">
        <div class="top-search-cons" v-if="!isLook">
            <div class="prepend-form-item">
                <div class="prepend-item-label">区域名称</div>
                <el-input v-model="filterText" class="prepend-item-input" placeholder="请输入"></el-input>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchFilterText">查询</el-button>
        </div>
        <div class="tree-modal-cons">
            <el-tree
                ref="menuTree"
                :data="menuTreeData"
                :props="menuTreeProps"
                :highlight-current="true"
                :show-checkbox="showCheckbox"
                node-key="id"
                :default-expand-all="defaultExpandAll"
                :filter-node-method="filterNode"
            ></el-tree>
        </div>
        <span slot="footer" class="dialog-footer" v-if="!isLook">
            <el-button @click="treeVisible = false">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="selectTreeNode">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { BasicRegionApi } from "@/apis";
import { mapState } from 'vuex'

export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        showCheckbox: {
            type: Boolean,
            default: true
        },
        defaultExpandAll: {
            type: Boolean,
            default: true
        },
        level: {
            type: [String, Number],
            default: ''
        },
        isCanUpdate: {
            type: Boolean,
            default: true
        },
        userRegionId: {
            type: [String, Number],
            default: ''
        },
        isLook: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menuTreeData: [],
            menuTreeProps: {
                children: 'childBasicRegionDtoList',
                label: 'regionName'
            },
            treeVisible: false,
            filterText: '',
        }
    },
    mounted() {

    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.regionName.indexOf(value) !== -1;
        },
        searchFilterText() {
            this.$refs.menuTree.filter(this.filterText);
        },
        getMenuTree() {
            let params = {
                regionId: this.userRegionId
            }
            BasicRegionApi.fiveLevelRegion(params).then((res) => {
                if (res.code === 0) {
                    this.menuTreeData = res.data || []
                }
            })
        },
        selectTreeNode() {
            if (this.showCheckbox) {
                this.$emit('selectTree', this.$refs.menuTree.getCheckedKeys(), this.$refs.menuTree.getCheckedNodes())
            } else {
                this.$emit('selectTree', this.$refs.menuTree.getCurrentKey(), this.$refs.menuTree.getCurrentNode())
            }
        },
        setCheckedKeys(v) {
            if (this.$refs.menuTree) {
                if (this.showCheckbox) {
                    this.$refs.menuTree.setCheckedKeys(v)
                } else {
                    this.$refs.menuTree.setCurrentKey(v)
                }
            } else {
                this.$nextTick().then(() => {
                    if (this.showCheckbox) {
                        this.$refs.menuTree.setCheckedKeys(v)
                    } else {
                        this.$refs.menuTree.setCurrentKey(v)
                    }
                })
            }
        },
        openModal() {
            this.getMenuTree()
            this.treeVisible = true
        },
        closeModal() {
            this.treeVisible = false
        }
    }
}
</script>
<style scoped lang="less">
.tree-modal-cons {
    height: 400px;
    overflow: auto;
    margin-top: 20px;
}
.top-search-cons {
    display: flex;
    justify-content: space-between;
}
.prepend-form-item {
    display: flex;
    flex: 1;
    margin-right: 20px;
    .prepend-item-label {
        width: 100px;
        border: 1px solid #e6e6e6;
        background-color: #F3F4F6;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px 0 0 8px;
    }
    .prepend-item-input {
        flex: 1;
        overflow: hidden;
        ::v-deep {
            .el-input__inner {
                border-radius: 0 8px 8px 0;
            }
        }
    }
}
</style>